import React, { useState, useRef } from "react";
import { motion } from "framer-motion";
import emailjs from "@emailjs/browser";
import "./Contact.css";

const Contact = () => {
  const form = useRef();
  const [loading, setLoading] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  // Form state
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    website: "",
    goal: "Lead Gen",
    budget: "",
    message: "",
  });

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setSubmitStatus(null);

    // EmailJS service configuration
    // You'll need to sign up at https://www.emailjs.com/ and replace these with your actual IDs
    const serviceId = "service_id"; // Replace with your EmailJS service ID
    const templateId = "template_id"; // Replace with your EmailJS template ID
    const publicKey = "public_key"; // Replace with your EmailJS public key

    // Prepare template parameters
    const templateParams = {
      to_email: "arez.khoshnaw@kynetic.krd",
      from_name: formData.name,
      from_email: formData.email,
      website: formData.website,
      goal: formData.goal,
      budget: formData.budget,
      message: formData.message,
    };

    // Send email using EmailJS
    emailjs
      .send(serviceId, templateId, templateParams, publicKey)
      .then((response) => {
        console.log("Email sent successfully:", response);
        setSubmitStatus("success");
        // Reset form
        setFormData({
          name: "",
          email: "",
          website: "",
          goal: "Lead Gen",
          budget: "",
          message: "",
        });
      })
      .catch((error) => {
        console.error("Email sending failed:", error);
        setSubmitStatus("error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // Goals options
  const goalOptions = [
    "Lead Gen",
    "Brand Awareness",
    "Website Traffic",
    "Sales",
    "Other",
  ];

  return (
    <main id="main-content" className="contact-page">
        <div className="contact-form-section">
          <div className="contact-form-container">
            <motion.h1
              className="contact-title"
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              Contact Kynetic
            </motion.h1>

            <motion.form
              ref={form}
              className="contact-form"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              onSubmit={handleSubmit}
            >
              <div className="form-group">
                <label htmlFor="contact-name">First and last name</label>
                <input
                  id="contact-name"
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="First & Last Name"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="contact-email">Work email</label>
                <input
                  id="contact-email"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Work Email"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="contact-website">Company website</label>
                <input
                  id="contact-website"
                  type="url"
                  name="website"
                  value={formData.website}
                  onChange={handleChange}
                  placeholder="Company Website"
                />
              </div>

              <div className="form-group">
                <label htmlFor="contact-goal">Primary goal</label>
                <select
                  id="contact-goal"
                  name="goal"
                  value={formData.goal}
                  onChange={handleChange}
                  required
                >
                  <option value="" disabled>
                    What is your primary goal?
                  </option>
                  {goalOptions.map((goal, index) => (
                    <option key={index} value={goal}>
                      {goal}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="contact-budget">Monthly marketing budget</label>
                <input
                  id="contact-budget"
                  type="text"
                  name="budget"
                  value={formData.budget}
                  onChange={handleChange}
                  placeholder="Monthly Marketing Budget"
                />
              </div>

              <div className="form-group">
                <label htmlFor="contact-message">Project message</label>
                <textarea
                  id="contact-message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Tell us about your project"
                  rows="5"
                  required
                ></textarea>
              </div>

              <button
                type="submit"
                className={`submit-button ${loading ? "loading" : ""} ${
                  submitStatus ? `status-${submitStatus}` : ""
                }`}
                disabled={loading}
              >
                {loading
                  ? "Sending..."
                  : submitStatus === "success"
                  ? "Message Sent!"
                  : submitStatus === "error"
                  ? "Failed to Send"
                  : "Submit"}
              </button>

              {submitStatus === "success" && (
                <div className="form-status success" role="status">
                  <p>Thank you for your message! We'll get back to you soon.</p>
                </div>
              )}

              {submitStatus === "error" && (
                <div className="form-status error" role="alert">
                  <p>
                    Sorry, there was an error sending your message. Please try
                    again or contact us directly.
                  </p>
                </div>
              )}
            </motion.form>
          </div>
        </div>

        <div className="contact-direct-section">
          <motion.div
            className="contact-direct-container"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <h2 className="contact-direct-title">Contact Us Directly</h2>
            <div className="contact-direct-info">
              <p className="contact-person">Arez Khoshnaw</p>
              <p className="contact-email">arez.khoshnaw@kynetic.krd</p>
              <p className="contact-phone">+964 0750 555 5555</p>
            </div>
          </motion.div>
        </div>
    </main>
  );
};

export default Contact;
